import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { FieldRowVariant } from './FieldRow.constants';
import { fieldRowLabelStyles, fieldRowValueStyles, fieldRowWrapperStyles } from './FieldRow.styles';

const FieldRow = ({
  label,
  value,
  isChanged = false,
  variant = FieldRowVariant.TEXT,
  bordered = false,
}) => (
  <Box sx={fieldRowWrapperStyles({ isChanged, variant, bordered })}>
    <Typography color="text.secondary" sx={fieldRowLabelStyles} variant="regular14">
      {label}
    </Typography>
    <Typography color="text.secondary" sx={fieldRowValueStyles(isChanged)} variant="bold16">
      {value}
    </Typography>
  </Box>
);

FieldRow.propTypes = {
  label: PropTypes.string.isRequired,
  bordered: PropTypes.bool,
  isChanged: PropTypes.bool,
  value: PropTypes.node,
  variant: PropTypes.oneOf(Object.values(FieldRowVariant)),
};

export default FieldRow;
